"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFetched = isFetched;
exports.fetchImage = fetchImage;

var _q = _interopRequireDefault(require("q"));

var fetched = {};

function isFetched(src) {
  return fetched[src];
}

function fetchImage(src) {
  if (isFetched(src)) {
    return _q.default.Promise.resolve();
  }

  return new _q.default.Promise(function (resolve, reject) {
    var img = new Image();

    var onload = function onload() {
      fetched[src] = true;
      resolve();
    };

    img.onerror = reject;
    img.onload = onload;
    img.src = src;
  });
}